<template>
  <v-form
    fast-fail
    @submit.prevent="saveData"
    class="edit-user"
    v-click-outside="outsideCancelAction"
  >
    <h2 class="title mb-2">{{ $t("editUserModalComponent.title") }}</h2>
    <v-text-field
      v-model="userData.email"
      :label="$t('profile.email')"
      autocomplete="new-user"
    ></v-text-field>
    <v-text-field
      type="password"
      v-model="userData.password"
      :label="$t('profile.newPassword')"
      autocomplete="new-password"
    ></v-text-field>
    <v-select
      :label="$t('users.table.createUserModal.role')"
      :items="roles"
      item-title="value"
      item-value="key"
      v-model="userData.role"
    ></v-select>
    <v-select
      :label="$t('users.table.editModal.partner')"
      :items="this.partners"
      item-title="name"
      item-value="id"
      v-model="userData.partner"
      v-if="userData.role == 1"
    ></v-select>
    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("profile.cancel") }}
      </v-btn>
      <v-btn v-if="!isCreate" class="mb-2" @click="userDelete" color="red">
        {{ $t("profile.delete") }}
      </v-btn>
      <v-btn :disabled="!visibleButton" color="primary" @click="saveData">
        {{ $t("profile.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import { roleEnums } from "@/components/enums";

export default {
  name: "EditUserModal",
  props: {
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      userData: {
        id: undefined,
        email: "",
        password: "",
        role: undefined,
        partner: undefined,
      },

      defaultEmail: "",

      partners: [],
      roles: [],
    };
  },
  mounted() {
    this.setRoles();
    this.getUserData();
    this.getPartnerList();
  },
  methods: {
    ...mapActions({
      getPartners: "users/getPartners",
    }),
    getRoleString(value) {
      return value === 0
        ? this.$t("enums.role.superAdmin")
        : this.$t("enums.role.admin");
    },
    setRoles() {
      roleEnums.map((role) => {
        const currentRole = {
          key: role.key,
          value: this.$t(`enums.role.${role.value}`),
        };
        this.roles.push(currentRole);
      });
    },
    getPartnerList() {
      this.getPartners()
        .then((response) => {
          this.partners = response.result.map((partner) => {
            return { id: partner.id, name: partner.par_name };
          });
          this.userData.partner = this.user.par_id;
        })
        .catch(() => {});
    },
    getUserData() {
      this.userData.id = this.user.id;
      this.userData.email = this.user.email;
      this.userData.role = this.user.role;

      this.defaultEmail = this.user.email;
    },
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },
    saveData() {
      let createPayload = {
        id: this.userData.id,
        role: this.userData.role,
        par_id: this.userData.role === 1 ? this.userData.partner : null,
      };
      if (this.userData.password !== "") {
        createPayload.password = this.userData.password;
      }
      this.userData.email !== this.defaultEmail
        ? (createPayload["email"] = this.userData.email)
        : createPayload;

      this.$emit("saveUser", createPayload);
      this.emitter.emit("closeModal");
    },
    userDelete() {
      const payload = {
        title: this.$t("users.table.deleteModal.title"),
        subTitle: this.$t("users.table.deleteModal.subTitle"),
        userId: this.userData.id,
      };
      this.emitter.emit("showConfirmModal", payload);
    },
  },
  computed: {
    visibleButton() {
      return this.userData.role === 0
        ? this.userData.email !== "" &&
            (this.userData.email !== this.defaultEmail ||
              this.userData.password.length >= 6)
        : this.userData.email !== "" &&
            this.userData.partner !== null &&
            (this.userData.email !== this.defaultEmail ||
              this.userData.partner !== this.user.par_id ||
              (this.userData.password.length >= 6 &&
                this.userData.partner !== null));
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
